import React, { useState } from "react";
import { Link } from "react-router-dom";
import img1 from "../../assets/img/item/s1.png";
import img2 from "../../assets/img/item/s2.png";
import img3 from "../../assets/img/item/s3.png";
import img4 from "../../assets/img/item/s4.png";
import img5 from "../../assets/img/item/s5.png";
import img6 from "../../assets/img/item/s6.png";
import img7 from "../../assets/img/item/s7.png";
import img8 from "../../assets/img/item/s8.png";
import img from "../../assets/img/product/4.png";
import SearchForm from "../../components/SearchForm";
import SelectCard from "../../components/SelectCard";
import {
	BinanceIcon,
	EditIcon,
	Holding,
	ShareIcon,
	Star,
	Tags,
} from "../../icon/IconTheme";
import OwnerShowCaseContent from "./components/OwnerShowCaseContent";
const ShowCase = ({ ownerShowcase }) => {
	const [modalOpen, setModalOpen] = useState(false);
	return (
		<>
			<div className="filter-top-bar filter-top-bar-2">
				<SearchForm />
				<div className="select-grp select-grp-2 ms-auto">
					<SelectCard data={data} />
				</div>
			</div>
			<h4 className="section-title">NFT Showcase</h4>
			<div className="row g-4 g-xxl-5">
				<div className="col-lg-6">
					<img className="nft-showcase-img" src={img} alt="" />
				</div>
				<div className="col-lg-6">
					<div className="nft-showcase-cont">
						<ul className="holding-tag">
							<li>
								<Link to="#" className="active">
									<Tags />
									For Sale
								</Link>
							</li>
							<li>
								<Link to="#">
									<Holding /> Holding
								</Link>
							</li>
						</ul>
						<div className="mt-3 rating pb-1">
							<Star />
							<Star />
							<Star />
							<Star />
						</div>
						<div className="d-flex flex-wrap align-items-center">
							<h4 className="subtitle mb-0 me-3 me-lg-5">Hashima 3</h4>
							<div className="price">
								<BinanceIcon /> 0.21 BNB
							</div>
							{ownerShowcase && (
								<>
									<div
										className="text-white ms-3 cursor-pointer"
										onClick={() => setModalOpen(!modalOpen)}
									>
										<EditIcon />
									</div>
									<OwnerShowCaseContent
										modalOpen={modalOpen}
										setModalOpen={setModalOpen}
									/>
								</>
							)}
						</div>
						<div className="text">
							Lorem Ipsum is simply dummy text of the printing and
							typesetting industry. Lorem Ipsum has been the industry's
							standard dummy text ever since the 1500s, when an unknown
							printer took a galley of type and scrambled it to make a
							type specimen book. hen an unknown printer took a galley of
							type and scrambled it to make a type specimen book.hen an
							unknown printer took a galley of type and scrambled it to
							make a type specimen book.
						</div>
						<div className="showcase-wrapper">
							{data2 &&
								data2.map(({ title, text }, i) => (
									<Link to="#" className="showcase-item" key={i}>
										<h5 className="s-txt">{title}</h5>
										<span>{text}</span>
									</Link>
								))}
						</div>
						<div className="showcase-buttons">
							<button className="btn cmn-btn btn-outline">
								<ShareIcon /> Share
							</button>
							<button className="btn cmn-btn">Buy Hashima 1</button>
						</div>
					</div>
				</div>
			</div>
			<div
				style={{
					borderRadius: "20px",
					overflow: "hidden",
					marginTop: "56px",
				}}
			>
				<div className="activity-card-wrapper">
					<div className="activity-card">
						<div className="activity-card-inner">
							<h4 className="activity-title">Activity</h4>
							<div className="table-wrapper">
								{data3 && (
									<table className="table m-0 __table activity-table">
										<thead>
											<tr>
												<th>Type</th>
												<th>Name</th>
												<th>Price</th>
												<th>From</th>
												<th>To</th>
												<th>Date</th>
											</tr>
										</thead>
										<tbody>
											{data3.map(({ img, title }, i) => (
												<tr key={i}>
													<td>
														<div className="mobile-info activity-listing">
															<div className="subtext">Type</div>
															<div className="s-title">
																Listing
															</div>
															<div>as fixed price</div>
														</div>
													</td>
													<td>
														<div className="mobile-info">
															<div className="subtext">Item</div>
															<div className="table-item">
																<img src={img} alt="" />
																<div className="info">
																	<h6>{title}</h6>
																	<div className="rating">
																		<Star />
																		<Star />
																		<Star />
																		<Star />
																	</div>
																	<span>
																		Hash Score:{" "}
																		<span>12354657886</span>
																	</span>
																</div>
															</div>
														</div>
													</td>
													<td>
														<div className="mobile-info price activity-price">
															<div className="subtext">
																Price
															</div>
															<span className="text-body">
																$750
															</span>
															<div className="d-flex align-items-center info">
																<BinanceIcon /> 0.05 BNB
															</div>
														</div>
													</td>
													<td>
														<div className="mobile-info">
															<div className="subtext">From</div>
															<h6>12/22/2022</h6>
														</div>
													</td>
													<td>
														<div className="mobile-info">
															<div className="subtext">To</div>
															<h6>12/22/2022</h6>
														</div>
													</td>
													<td>
														<div className="mobile-info">
															<div className="subtext">Date</div>
															<h6>9 minutes Ago</h6>
														</div>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
const data2 = [
	{
		title: "ID",
		text: "12345",
	},
	{
		title: "Background",
		text: "Red Smoky",
	},
	{
		title: "Weapon",
		text: "Kantana",
	},
	{
		title: "Body",
		text: "Brown",
	},
	{
		title: "Background",
		text: "Red Smoky",
	},
	{
		title: "Weapon",
		text: "Kantana",
	},
	{
		title: "Accesories",
		text: "Kantana",
	},
	{
		title: "Body",
		text: "Brown",
	},
	{
		title: "Weapon",
		text: "Kantana",
	},
	{
		title: "Accesories",
		text: "Kantana",
	},
	{
		title: "Body",
		text: "Brown",
	},
	{
		title: "Accesories",
		text: "Kantana",
	},
];
const data = [
	{
		option: "Recently Listed",
		value: "1",
	},
	{
		option: "Last Month",
		value: "1",
	},
	{
		option: "Last Year",
		value: "1",
	},
	{
		option: "Archived",
		value: "1",
	},
];
const data3 = [
	{
		title: "Hashima 1",
		img: img1,
	},
	{
		title: "Hashima 1",
		img: img2,
	},
	{
		title: "Hashima 1",
		img: img3,
	},
	{
		title: "Hashima 1",
		img: img4,
	},
	{
		title: "Hashima 1",
		img: img5,
	},
	{
		title: "Hashima 1",
		img: img6,
	},
	{
		title: "Hashima 1",
		img: img7,
	},
	{
		title: "Hashima 1",
		img: img8,
	},
];
export default ShowCase;
